export default function VideoPlayer({
  src,
  poster,
  autoPlay = false,
  controls = true,
  muted = false,
  preload = "auto",
  style = {},
  ...props
}) {
  return (
    <video
      src={src}
      poster={poster}
      autoPlay={autoPlay}
      controls={controls}
      muted={muted}
      preload={preload}
      style={{
        width: "100%",
        aspectRatio: "16/9",
        background: "#000",
        ...style,
      }}
      {...props}
    >
      Sorry, your browser does not support video.
    </video>
  );
}
